import { useState } from 'react'
import { Button, Col, FloatingLabel, Form, Row } from 'react-bootstrap'
import SuccessModal from '../../common/successModel/index';
import { useTranslation } from 'react-i18next';
import constants from '../../../contants';
import './contact.css'
const { productionAPI } = constants;

function Contact() {
  const { t } = useTranslation();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    subject: '',
    email: '',
    phoneNumber: '',
    text: '',
  });
  const handleShowSuccessModal = () => setShowSuccessModal(true);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    // return;
    try {
      const response = await fetch(`${productionAPI}/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        handleShowSuccessModal();
        // Handle success, e.g., show a success message to the user
      } else {
        console.error('Failed to send email');
        // Handle failure, e.g., show an error message to the user
      }
    } catch (error) {
      console.error('Error sending email:', error);
      // Handle other errors, e.g., network issues
    }
  };
  return (
    <section id="contact-form" aria-labelledby="contact-form" className='contact-form-section'>
      <Row>
        <Col>
          <h2 id="contact-form-heading" className='contact-heading text-light'>{t("contactheading")}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className='contact-sub-heading'>{t("contactsubheading")}</p>
        </Col>
      </Row>
      <Row>
        <Col className='contact-form-container'>
          <Form className='contact-form' onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="contactName">
              <FloatingLabel controlId="contactName" label={t("fullname")}>
                <Form.Control name="subject" type="text" onChange={handleChange} placeholder={t("fullname")} autoComplete="name" required />
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="contactEmail">
              <FloatingLabel controlId="contactEmail" label={t("email")}>
                <Form.Control name="email" type="email" onChange={handleChange} placeholder={t("email")} autoComplete="email" required />
              </FloatingLabel>
            </Form.Group>
            <Form.Group className="mb-3" controlId="contactPhone">
              <FloatingLabel controlId="contactPhone" label={t("phonenumber")}>
                <Form.Control name="phoneNumber" type="tel" onChange={handleChange} placeholder={t("phonenumber")} autoComplete="tel" />
              </FloatingLabel>
            </Form.Group>
            <FloatingLabel controlId="contactMessage" label={t("message")}>
              <Form.Control
                as="textarea"
                placeholder={t("message")}
                name='text'
                style={{ height: '100px' }}
                onChange={handleChange}
                required
              />
            </FloatingLabel>
            <div className='d-flex justify-content-center'>
              <Button className='submit-btn' type="submit" aria-label="Send project enquiry">
                Get Quote
              </Button>
            </div>
          </Form>
          <SuccessModal show={showSuccessModal} handleClose={handleCloseSuccessModal} />
        </Col>
      </Row>
    </section>
  )
}

export default Contact
